import { useParams } from 'react-router-dom';
import { useGoToPath } from 'catering/hooks/navigation/useGoToPath';
import { buildMenuItemPath } from 'catering/helpers/paths';

export function useGoToMenuItem() {
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  return (menuItemSlug, isRedirect = false) =>
    go({
      path: buildMenuItemPath(locationSlug, menuItemSlug),
      isRedirect
    });
}
